import React from 'react'
import '../styles/basicLayout.css'
import '../styles/editRecipe.css'
import { ACTIONS_REQUIRED } from "../utils/constants";
import { mainBgColor } from "../utils/colors";

export default function SetActionReq({ visible, handleClose, title, stage, setStage }) {
  const { action, id } = { ...stage }
  return (
    <div id="popup1" className="overlay" style={{ visibility: visible ? 'visible' : 'hidden' }}>
      <div className="popup">
        <div className="top">
          <a className='close' onClick={handleClose}>&times;</a>
        </div>

        <h2>{title}</h2>

        <div className="content" style={{ flexDirection: 'column' }}>
          <form onChange={(e) => {
            setStage({ id, action: e.target.value })
            handleClose()
          }} 
            style={{
              display:'flex', 
              flexDirection:'row', 
              flex:1, 
              flexWrap:'wrap',
              color:mainBgColor,
              fontWeight:'bolder',
              fontSize:27,
            }} >
            <div style={{width:'50%'}}>
              <input type="radio" checked={action === ACTIONS_REQUIRED.TURN_PROD} value={ACTIONS_REQUIRED.TURN_PROD} />
              <span>{ACTIONS_REQUIRED.TURN_PROD}</span>
            </div>
            <div style={{width:'50%'}}>
              <input type="radio" checked={action === ACTIONS_REQUIRED.ADD_SAUCE} value={ACTIONS_REQUIRED.ADD_SAUCE} />
              <span>{ACTIONS_REQUIRED.ADD_SAUCE}</span>
            </div>
            <div style={{width:'50%'}}>
              <input type="radio" checked={action === ACTIONS_REQUIRED.ROTATE} value={ACTIONS_REQUIRED.ROTATE} />
              <span>{ACTIONS_REQUIRED.ROTATE}</span>
            </div>
            <div style={{width:'50%'}}>
              <input type="radio" checked={action === ACTIONS_REQUIRED.REMOVE_PROD} value={ACTIONS_REQUIRED.REMOVE_PROD} />
              <span>{ACTIONS_REQUIRED.REMOVE_PROD}</span>
            </div>
          </form>
          <button className="button" onClick={() => handleClose()}>Cancel</button>
        </div>
      </div>
    </div>
  )
}